module.exports = __webpack_public_path__ + "media/images/icons/twotone/crown-6f08a01122996272524b2c21bf350188.svg";